import React, { useContext } from "react";

import Banner from "../../../../../atoms/banner/Banner";
import Container from "../../../../../atoms/page/Page";
import { EventContext } from "../../context";
import StepContainer from "../../components/StepContainer";
import GameStatus from "./GameStatus";
import { useEvent } from "../../../../../../hooks/useEvent";
import { useGameStatus } from "../../../../../../hooks/useGameStatus";
import { usePollingModelConfiguration } from "../../../../../../hooks/useModelConfiguration";
import LoadingSpinner from "../../../../../atoms/loadingspinner/LoadingSpinner";

const RunSimulation: React.FC = () => {
  const { config } = useContext(EventContext);

  const { data: event, error: errorEvent } = useEvent(config!.id);
  const {
    data: gameStatus,
    error: errorGameStatus,
    refresh: refreshGameStatus,
  } = useGameStatus(config!.id);

  const { data: modelConfig } = usePollingModelConfiguration(config!.id, 5000);

  let content = null;
  if (
    !event ||
    !gameStatus ||
    modelConfig == null ||
    modelConfig?.state === "initialising"
  ) {
    content = (
      <Container noOverflow>
        <LoadingSpinner
          text={modelConfig?.progressMessage ?? "Setting up model"}
        />
      </Container>
    );
  } else {
    content = (
      <GameStatus
        event={event}
        game={gameStatus}
        fetchGameStatus={refreshGameStatus}
      />
    );
  }

  return (
    <StepContainer>
      <Banner
        type="error"
        active={!!errorEvent}
        message={errorEvent?.message}
      />
      <Banner
        type="error"
        active={!!errorGameStatus}
        message={errorGameStatus?.message}
      />
      {content}
    </StepContainer>
  );
};

export default RunSimulation;
